import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import BlockUi from 'react-block-ui'
import ContentBox from '../../../../layout/component/ContentBox'
import Row from '../../../../bootstrap/component/Row'
import Column from '../../../../bootstrap/component/Column'
import Validation from './UploadValidation'

const dropzoneStyle = {
    width: '100%',
    height: '200px',
    borderWidth: '2px',
    borderColor: 'rgb(102, 102, 102)',
    borderStyle: 'dashed',
    borderRadius: '5px',
    padding: '35px',
    textAlign: 'center',
    cursor: 'pointer',
    marginTop: '32px',
}

const FoilMetadataUpload = ({ uploadFoilCSV, fetching, error }) => {
    return (
        <BlockUi tag="div" blocking={fetching}>
            <ContentBox title="Foil Metadata Upload">
                <Validation error={error}/>
                <Row>
                    <Column>
                        <Dropzone
                            multiple={false}
                            style={dropzoneStyle}
                            disablePreview={true}
                            onDrop={(fileList) => {
                                uploadFoilCSV(fileList[0])
                            }}>
                            <p>Click to upload CSV</p>
                        </Dropzone>
                    </Column>
                </Row>
            </ContentBox>
        </BlockUi>
    )
}

FoilMetadataUpload.propTypes = {
    uploadFoilCSV: PropTypes.func.isRequired,
    error: PropTypes.object,
    fetching: PropTypes.bool.isRequired,
}

export default FoilMetadataUpload





// WEBPACK FOOTER //
// ./src/modules/foil/component/overview/csv-upload/FoilMetadataUpload.js